module.exports = " <li class=product-list__item> <a href=# v-on:click.prevent=\"getProduct(product.Id, category)\">{{product.Name}}</a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/products/ProductsListItem.vue
// module id = 205
// module chunks = 0